module.exports = __webpack_public_path__ + "static/media/welcome-modal-question.275b8206.jpg";